import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { DOMINANT_STRIP } from './resultsMockData'

/** Plutchik-style colored bar showing the strongest emotion at each moment. */
export default function DominantStrip() {
  const theme = useTheme()
  const c = theme.affexy.colors
  const { t } = useTranslation('results')

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      <Box sx={{ display: 'flex', gap: '1px', height: 14, borderRadius: '4px', overflow: 'hidden' }}>
        {DOMINANT_STRIP.map((s, i) => (
          <Box key={i} sx={{ flex: 1, bgcolor: theme.affexy.emotion[s], opacity: 0.92 }} />
        ))}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 10.5,
          color: c.ink48,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        <span>0:00</span>
        <span>{t('hero.dominantStrip')}</span>
        <span>0:30</span>
      </Box>
    </Box>
  )
}
